/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";
import { useTranslation } from "react-i18next";

export interface Column {
  header: string;
  key: string;
  render?: (row: any, index: number) => React.ReactNode;
}

interface ContainerInventoryTableProps {
  columns: Column[];
  data: any[];
  renderAction?: (row: any) => React.ReactNode;
  actionHeader?: string;
  emptyMessage?: string;
}

const ContainerInventoryTable: React.FC<ContainerInventoryTableProps> = ({
  columns,
  data,
  renderAction,
  actionHeader = "Actions",
  emptyMessage = "No data available",
}) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto overflow-y-auto max-h-[500px]">
      <table className="w-full text-left">
        <thead className="sticky top-0 bg-[#F8FAFC] text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-100">
          <tr>
            {columns.map((col, index) => (
              <th key={index} className="px-10 py-2">
                {t(col.header)}
              </th>
            ))}

            {renderAction && (
              <th className="px-10 py-4 text-center">
                {actionHeader}
              </th>
            )}
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-100">
          {data.length > 0 ? (
            data.map((row, i) => (
              <tr
                key={i}
                className="hover:bg-slate-50/50 transition-colors"
              >
                {columns.map((col, idx) => (
                  <React.Fragment key={idx}>
                    {col.render ? (
                      col.render(row, i)
                    ) : (
                      <td className="px-10 py-3">
                        {row[col.key]}
                      </td>
                    )}
                  </React.Fragment>
                ))}

                {renderAction && (
                  <td className="px-10 py-3 text-left">
                    {renderAction(row)}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length + (renderAction ? 1 : 0)}
                className="px-10 py-8 text-center text-slate-400"
              >
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ContainerInventoryTable;